
import {defineComponent} from 'vue';
import {IonButton, IonButtons, IonContent, IonHeader, IonModal, IonTitle, IonToolbar} from '@ionic/vue';
import BaseLoader from '@/components/BaseLoader.vue';

export default defineComponent({
    name: 'CardModal',
    components: {BaseLoader, IonButton, IonButtons, IonModal, IonContent, IonHeader, IonToolbar, IonTitle},
    props: {
        size: {
            type: String,
            required: false,
        },
        title: {
            type: String,
            required: true,
        },
        // Darkens the page behind the modal, so it is clear the page itself is not usable.
        backdrop: {
            type: Boolean,
            default: false,
        },
        // Shows a back button in the header that closes the modal.
        closable: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            viewDidEnter: false,
            isOpen: false,
            topOutlet: document.querySelector('.modal-trigger-outlet'),
        };
    },
});
